import React from 'react';
import { InfoMessage, Loading } from '@fasstech/middle-design-system';
import { RedirectionCcnInfo } from './RedirectionCcnInfo.jsx';

const CcnOfferInfos = ({ loadingCcnOffer, showInfoMessage, getMiddleText, redirectionInfo, canGoNext }) => {
  return (
    <div className={'w-1/2 flex gap-4 flex-col'}>
      {loadingCcnOffer ? (
        <div className="flex items-center justify-center w-full">
          <Loading />
        </div>
      ) : (
        showInfoMessage && (
          <InfoMessage iconName="lightbulb">
            {canGoNext
              ? getMiddleText('ENTREPRISE_CCN_OFFRE_ASSUREUR_MESSAGE_INFO')
              : getMiddleText('ENTREPRISE_CCN_PAS_OFFRE_ASSUREUR_MESSAGE_INFO')}
          </InfoMessage>
        )
      )}
      {redirectionInfo && (
        <RedirectionCcnInfo
          comment={redirectionInfo.comment}
        />
      )}

    </div>
  );
};

export default CcnOfferInfos;
